import { request } from '../request';

/**
 * Login
 *
 * @param userName User name
 * @param password Password
 */
export function fetchLogin(params: { phone: string; code: string; }) {
  return request<Api.Auth.LoginToken>({
    url: '/ys-digital-commerce/sys/ysUserLoginPcBySms',
    method: 'post',
    data: {
      ...params
    }
  });
}

export function fetchLoginByCode(params: { username: string, password: string, captcha: string, checkKey: number }) {
  return request<Api.Auth.LoginToken>({
    url: '/ys-digital-commerce/sys/login',
    method: 'post',
    data: {
      ...params
    }
  });
}

/** Get user info */
export function fetchGetUserInfo() {
  return request<Api.Auth.UserInfo>({ url: '/ys-digital-commerce/sys/user/getUserInfo' });
}

/** Get imgCode */
export function fetachGetImgCode(checkKey: number) {
  return request<Api.Auth.ImgCode>({ url: `/ys-digital-commerce/sys/randomImage/${checkKey}` });
}
/** 得到手机短信验证码 */
export function fetachGetPhoneCode(phone: string) {
  return request<Api.Common.CommonEmpty>({ url: `/ys-digital-commerce/sys/sendPc`, params: { phone } });
}


/**
 * Refresh token
 *
 * @param refreshToken Refresh token
 */
export function fetchRefreshToken(refreshToken: string) {
  return request<Api.Auth.LoginToken>({
    url: '/auth/refreshToken',
    method: 'post',
    data: {
      refreshToken
    }
  });
}

/**
 * return custom backend error
 *
 * @param code error code
 * @param msg error message
 */
export function fetchCustomBackendError(code: string, msg: string) {
  return request({ url: '/auth/error', params: { code, msg } });
}

export function fetchCustomBackend() {
  return request({ url: '/ys-digital-commerce/sys/logout', params: {} });
}

/**
 * @description 后端缓存
 */
export function fetchRefleshCache() {
  return request({ url: '/ys-digital-commerce/sys/dict/refleshCache', params: {} });
}


//系统设置-获取指定租户登录页信息
export function sysTenantInfoGetInfoByPath(path: string) {
  return request({
    url: `/ys-digital-commerce/sysTenantInfo/getInfoByPath`,
    method: 'get',
    params: {
      path
    }
  });
}
